import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Grid, Card, CardHeader, CardContent, Snackbar, IconButton } from '@mui/material';

import FilterModal from '../../Components/Modal/Filter';
import Placeholder from "../../Components/UI/Placeholder";

import { makeStyles } from "@material-ui/core/styles";

import { getTrainerUsageData } from "../Report/Services";
import { getRolesBySiteUuid, getUsersByRoleId } from "../Users/Services";

import { currentMonth, getFormatedDate, fancyTimeHhMmSs } from "../../Js/TimeAndDate";
import { joinByKeys } from "../../Js/Common";

import StackBarChart from '../Report/Trainers/StackBarChart';

const TrainerLeaderBoard = (props) => {
    //Hooks
    const styles = useStyles();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // State     
    const [trainerReportData, setTrainerReportData] = useState([]);
    const [selectedTrainer, setSelectedTrainer] = useState([]);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [trainers, setTrainers] = useState([]);

    const [stateSnackbar, setStateSnackbar] = useState({ open: false, vertical: 'bottom', horizontal: 'center' });
    const { vertical, horizontal, open } = stateSnackbar;

    useEffect(() => {
        initialRender();
    }, []);

    const initialRender = useCallback(async () => {
        let trainerUuids = [];
        let objCurrentMonth = currentMonth('YYYY-MM-DD');        
        let startDate = objCurrentMonth.startOfMonth;
        let endDate = objCurrentMonth.endOfMonth;
        setStartDate(startDate);
        setEndDate(endDate);        
        if (userInfo.rolesInfo.title.toLowerCase() !== 'trainer') {
            let resTrainer = await getTrainerRole();
            if (resTrainer) {
                let params = {
                    query: {
                        $select: ['uid', 'name'],
                        role_uid: resTrainer.uid,
                        site_uuid: userInfo.site_uuid,
                        status: true,
                        $limit:-1
                    }
                }
                let resUsersData = await getUsersByRoleId(params);
                console.log("resUser===>",resUsersData);
                if (resUsersData.data.length > 0) {
                    let trainerInfo = [];
                    resUsersData.data.map((userData) => {
                        delete (userData.rolesInfo);
                        let newUserData = {};
                        newUserData.value = joinByKeys(userData.name, ['firstname', 'lastname'], ' ');
                        newUserData.id = userData.uid;
                        return trainerInfo.push(newUserData);
                    });
                    trainerUuids = trainerInfo.map(value => value.id);
                    setSelectedTrainer(trainerUuids);
                    setTrainers(trainerInfo);
                }
            }
        }
        await fetchTrainerReports(startDate, endDate, trainerUuids);
    }, [])


    const handleFilterReport = async (childParams) => {
        // console.log("childParamas", childParams);
        setSelectedTrainer(childParams.selectedTrainers);
        setStartDate(childParams.start_date);
        setEndDate(childParams.end_date);
        await fetchTrainerReports(childParams.start_date, childParams.end_date, childParams.selectedTrainers);
    };


    const fetchTrainerReports = async (start_date, end_date, trainerIds = []) => {
        if (trainerIds.length <= 0) {
            setStateSnackbar({ ...stateSnackbar, open: true });
            return false;
        }

        let params = {
            query: {
                'site_uuid': userInfo.site_uuid,
                'fromDate': start_date,
                'toDate': end_date,
                'reportType': 'teacherWise',
                'user_uid': trainerIds
            }
        };

        let resTrainerData = await getTrainerUsageData(params);
        console.log("resTrainerData",resTrainerData);
        if (resTrainerData.data.length > 0) {
            resTrainerData.data.sort((a,b) => {
                return b.totalTime - a.totalTime;
            });
            console.log("resTrainerData.data", resTrainerData.data);
            setTrainerReportData(resTrainerData.data);
        } else {
            setTrainerReportData([]);
        }
    };

    const getTrainerRole = async () => {
        let params = {
            query: {
                $select: ['uid', 'title'],
                title: 'Trainer',
                site_uuid: userInfo.site_uuid
            }
        }
        let resRolesData = await getRolesBySiteUuid(params);
        return resRolesData.data[0];
    };

    const fetchTrainer = (uid) => {
        let findObj = trainers.find((obj) => {
            return obj.id === uid
        });
        return findObj.value;
    };

    const handleClose = () => {
        setStateSnackbar({ ...stateSnackbar, open: false });
    };

    return (
        <Grid container sx={{ flexDirection: "row" }}>
            <Grid item xs={12}>
                <Card sx={{ borderRadius: 5, boxShadow: '3px 3px 5px 1px #dddddd' }}>
                    <CardHeader
                        titleTypographyProps={{ fontSize: '1.2vw', fontWeight: '700', textAlign: 'left', pl: 2 }}
                        subheaderTypographyProps={{ fontSize: '0.9vw', fontWeight: '600', textAlign: 'left', pl: 2 }}
                        sx={{ backgroundColor: '#3eda00ff', color: '#5f5600ff' }}
                        action={
                            <IconButton
                                variant="text"
                                sx={{ fontSize: '1.2rem', fontWeight: '600', color: '#5f5600ff', padding: 0, mt: 0.3 }}
                            >
                                <FilterModal
                                    press={handleFilterReport}
                                    defaultSelectedValues={selectedTrainer}
                                    isAllTrainer={true}
                                />
                            </IconButton>
                        }
                        title="Trainer Leader Board"
                        subheader={(
                            getFormatedDate(startDate, 'DD MMM YYYY') + ' - ' + getFormatedDate(endDate, 'DD MMM YYYY')
                        )}
                    >
                    </CardHeader>
                    <CardContent className={styles.scrollBar} sx={{ height: '48vh', overflow: 'auto' }}>
                        {(trainerReportData.length > 0) ? (
                            <StackBarChart
                                fetchTrainer={fetchTrainer}
                                stackBarData={trainerReportData}
                                isHorizontal={true}
                                chartWidth={'90%'}
                                chartHeight={'850px'}
                            />
                        ) : (
                            <Placeholder
                                primaryText="No trainer"
                                secondaryText="No data found!"
                                image="assign"
                            ></Placeholder>
                        )}
                    </CardContent>
                    {/* <CardActions sx={{ justifyContent: 'flex-end', pr: 4, backgroundColor: '#f7f7f7' }}>
                        <Button size="small" sx={{ fontSize: '0.9rem', fontWeight: '600' }}>View All</Button>
                    </CardActions> */}
                </Card>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={6000}
                open={open}
                onClose={handleClose}
                message="Please select trainer!"
                key={vertical + horizontal}
            />
        </Grid>
    );
};
const useStyles = makeStyles({
    scrollBarHeight: {
        "&::-webkit-scrollbar": {
            width: "0.0em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default TrainerLeaderBoard; 